import React, { useEffect, useState } from "react";
import { BsPencilFill } from "react-icons/bs";

import axios from "axios";
import { TELEMETRY_API } from "../../constants/serverConfig";
import { useLocation } from 'react-router-dom';

const DatasetDetailsMessageSub = ({ modaldata, showModal, sensitivitytypeclass, certifiedetails, datasetId }) => {

  const location = useLocation();
  const isMetric = location.pathname.includes('metric');

  const [oneMonthUserVisitCount, setPastOneMonthUserVisit] = useState("");

  const classificationType = (classification) => {
    let confidenceFlag = classification?.indexOf("confidential") > -1;
    // let internalFlag =  classification.indexOf("internal") > -1;
    // modaldata.securityClassification?.some(function (
    //   object
    // ) {
    //   return object.indexOf("confidential") > -1;
    // });
    let internalFlag = classification?.indexOf("internal") > -1;
    //  modaldata.securityClassification?.some(function (
    //   object
    // ) {
    //   return object.indexOf("internal") > -1;
    // });
    let publicFlag = classification?.indexOf("public") > -1;
    // modaldata.securityClassification?.some(function (object) {
    //   return object.indexOf("public") > -1;
    // });

    if (confidenceFlag) {
      // setSensitivityTypeClass("sensitivity-confidencial");
      return "sensitivity-confidencial";
    } else if (internalFlag) {
      // setSensitivityTypeClass("sensitivity-internal");
      return "sensitivity-internal";
    } else if (publicFlag) {
      // setSensitivityTypeClass("sensitivity-public");
      return "sensitivity-public";
    } else {
      // setSensitivityTypeClass("bg-white");
      return "bg-white";
    }
    // setSensitivityType("#008000")
  };


  const getUserVisitInPastOneMonth = () => {
    axios
      .get(
        TELEMETRY_API + "util/users/count/datasetId?datasetId=" + `${datasetId}`
      )
      .then((res) => {
        setPastOneMonthUserVisit(res.data);
      })
      .catch((error) => {
        console.log(error)
        // toast.error("Error while fetching the past one month user data", {
        //   toastId: "onemonthuserdata",
        //   position: "top-right",
        //   autoClose: 6000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        // });
        console.error(error)
      });
  };

  useEffect(() => {
    getUserVisitInPastOneMonth()
  }, [])

  // let allowner = []
  //   .concat(modaldata.owner, modaldata.businessOwner, modaldata.technologyContact)
  //   .filter((item, i, arr) => item && arr.indexOf(item) === i);
  const allowner = [
    ...(Array.isArray(modaldata.owner) ? modaldata.owner : []),
    ...(Array.isArray(modaldata.businessOwner) ? modaldata.businessOwner : modaldata.businessOwner ? [modaldata.businessOwner] : []),
    ...(Array.isArray(modaldata.technologyContact) ? modaldata.technologyContact : modaldata.technologyContact ? [modaldata.technologyContact] : []),
  ];

  const businessOwners = modaldata.businessOwner || ["--"];
  const technologyContact = modaldata.technologyContact || "--";

  return (
    <div class="details-head-container1" style={{ width: "35%" }}>
      <div>
        <div className="d-flex dhc-container-label">
          <label>{isMetric ? "Metric Classification and Sensitivity" : "Data Classification and Sensitivity"}</label>
          <BsPencilFill size={15} className="stroke-2 cursor-pointer " onClick={() => showModal("securityClassification")} />
        </div>
        <div className="dhc-container-classification">
          {modaldata.securityClassification?.map((classi, index) => (
            <p className={"dhc-header-message-classi m-1 " + classificationType(classi)}>
              {classi?.replace("securityclassification.", "")}
            </p>
          )) || <span className="px-2"><i>Update Classification...</i></span>}
          {modaldata.sensitivity?.map((classi, index) => (
            <p key={index} className="dhc-header-message-classi m-1">
              {classi?.includes("securityclassification.confidential.") &&
                classi?.replace("securityclassification.confidential.", "")}
              {classi?.includes("securityclassification.internal.") &&
                classi?.replace("securityclassification.internal.", "")}
              {classi?.includes("securityclassification.public.") &&
                classi?.replace("securityclassification.public.", "")}
            </p>

          ))}
          {/* <p className="dhc-header-message-classi m-1">test</p>
          <p className="dhc-header-message-classi m-1">test</p>
          <p className="dhc-header-message-classi m-1">test</p>
          <p className="dhc-header-message-classi m-1">test</p> */}
        </div>
      </div>

      {/* <div>
        <div className="d-flex dhc-container-label">
          <label>Owner</label>
          <BsPencilFill size={15} className="stroke-2 cursor-pointer " onClick={() => showModal("owner")} />
        </div>
        <div className="dhc-container">
          {allowner.length > 0 ? (
            allowner.map((owner, index) => (
              <p key={index} style={{ fontSize: "12px", fontWeight: "900" }}>
                {owner}
                {index < allowner.length - 1 && ", "}
              </p>
            ))
          ) : (

            <p style={{ fontSize: "12px", fontWeight: "900" }}>--</p>
          )}
        </div>
      </div> */}

      <div>
        <div className="d-flex dhc-container-label">
          <label>Business Owner</label>
          <BsPencilFill
            size={15}
            className="stroke-2 cursor-pointer "
            onClick={() => showModal("Businessowner")}
          />
        </div>
        <div className="dhc-container">
          {Array.isArray(businessOwners) ? (
            businessOwners.map((owner, index) => (
              <p key={index} style={{ fontSize: "12px" }}>
                {owner}
              </p>
            ))
          ) : (
            <p style={{ fontSize: "12px" }}>--</p>
          )}
        </div>
      </div>
      <div>
        <div className="d-flex dhc-container-label">
          <label>Tech Owner</label>
          <BsPencilFill
            size={15}
            className="stroke-2 cursor-pointer"
            onClick={() => showModal("Techowner")}
          />
        </div>
        <div className="dhc-container">
          {Array.isArray(technologyContact) ? (
            technologyContact.map((contact, index) => (
              <p key={index} style={{ fontSize: "12px" }}>
                {contact}
              </p>
            ))
          ) : (
            <p style={{ fontSize: "12px" }}>--</p>
          )}
        </div>
      </div>
      {/* <div className="dhc-container">
        <MdOutlineLocalPostOffice size={18} />
        <a href="javascript:void(0)">Steward: {modaldata?.steward || "N/A"} </a>
      </div>
      <div className="dhc-container">
        <MdOutlineLocalPostOffice size={18} />
        <a href="javascript:void(0)">Publisher Group</a>
      </div>
      <div className="dhc-container">
        <MdOutlineLocalPostOffice size={18} />
        <a href="javascript:void(0)">Editor Group</a>
      </div> */}

      <div className="dhc-containerI">
        {/* <div>
          Size: <span>{modaldata?.dataset?.approximateSize || "--"}</span>
        </div> */}
        <div>
          Last Modified: <span>{modaldata?.certification?.certificationDate || "--"}</span>
        </div>
        {/* <div>
          Rows: <span>{modaldata?.rowCount || "--"}</span>
        </div> */}
        <div>
          Columns: <span>{modaldata?.columns?.length || "--"}</span>
        </div>
        {certifiedetails.certifiedFlag ? (
          <>
            <div>
              Certified By: <span>{certifiedetails?.certifiedBy}</span>
            </div>
            <div>
              Certified Date: <span>{certifiedetails?.certificationDate}</span>
            </div>
          </>
        ) : (
          ""
        )}

        {/* <div>Accessed in the last 1 month:<span>{oneMonthUserVisitCount}</span></div> */}
      </div>
    </div >
  );
};

export default DatasetDetailsMessageSub;
